import { render, staticRenderFns } from "./OrderReviewProductLoyalty.vue?vue&type=template&id=04cac213&scoped=true&"
import script from "./OrderReviewProductLoyalty.vue?vue&type=script&lang=js&"
export * from "./OrderReviewProductLoyalty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cac213",
  null
  
)

export default component.exports